export const scrollToFilter = () => {
  document.querySelector('.filters')?.scrollIntoView({ behavior: 'smooth' });
};
